import { IRouteObject } from 'common/types';
import { ROUTES_PATH } from 'layout/constants';

export function checkPermission(permissions: string[], listRole?: string[][]): boolean {
  if (!listRole?.length) {
    return true;
  }
  return !!listRole.find((groupRole) => {
    return groupRole.every((role) => {
      return permissions?.includes(role);
    });
  });
}

export const mappedRoutesPermission = (
  permissions: string[],
  list: IRouteObject[]
): IRouteObject[] => {
  return permissions
    ? (list
        .map((one) => {
          const children = one.children ? mappedRoutesPermission(permissions, one.children) : [];

          if (!checkPermission(permissions, one.listRole)) {
            return undefined;
          }
          if (one.children && one.children?.length > 0 && children?.length === 0) {
            return undefined;
          }
          return {
            ...one,
            children: one.children && mappedRoutesPermission(permissions, one.children),
          };
        })
        .filter(Boolean) as IRouteObject[])
    : list;
};

export const routesByUserRoles = (roles, list: IRouteObject[]) => {
  const routesList = [...list];
  const allowedToAccess = roles?.systemRoles?.length || roles?.adminRoles?.length;
  if (allowedToAccess) return routesList;
  return routesList.filter(({ path }) => path !== 'ad');
};

export interface MenuPersona {
  isParent: boolean;
  isGuest: boolean;
}

/**
 * Ẩn menu theo persona. Chỉ đặt cờ `hidden` (KHÔNG bỏ route khỏi cây) để người dùng gõ URL thẳng
 * vẫn bị ParentBlockedRoute đẩy về Dashboard, không rơi vào 404.
 * - Phụ huynh: ẩn QR NCC TPAT (xlsx sheet 03: FSOL = "Không" với Min Client2).
 * - Khách: ẩn QR NCC TPAT (docx 07.08 [76]: "QR NCC — Không cho xem gì") + ẩn nhóm "Quản trị hệ
 *   thống" (path 'ad'). Đây là lớp hiển thị "chắc chắn" — không phụ thuộc `roles.systemRoles`/
 *   `adminRoles` còn sót trong redux-persist từ phiên người dùng thật trước đó (routesByUserRoles
 *   đọc roles đó nên có thể bị lệch); xem thêm lớp dọn dữ liệu ở `logInAsGuest` (authReducer.tsx).
 */
export const hideRestrictedMenus = (
  persona: MenuPersona,
  list: IRouteObject[]
): IRouteObject[] => {
  const hideSupplier = persona.isParent || persona.isGuest;
  const hideAdmin = persona.isGuest;
  if (!hideSupplier && !hideAdmin) return list;
  return list.map((one) => {
    let hidden = one.hidden;
    if (hideSupplier && one.path === ROUTES_PATH.supplier.index) hidden = true;
    if (hideAdmin && one.path === ROUTES_PATH.ad.index) hidden = true;
    return {
      ...one,
      hidden,
      children: one.children ? hideRestrictedMenus(persona, one.children) : one.children,
    };
  });
};
